import '../../styles/styles.css';

import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';

import Layout from '../../components/Layout';

import AnimateIn from '../../components/AnimateIn';
import VimeoVideo from '../../components/VimeoVideo';
import Image from '../../components/Image';
import ColumnLists from '../../components/ColumnLists';
import LinkButton from '../../components/LinkButton';
import LinkList from '../../components/LinkList';
import Quote from '../../components/Quote';
import WorkHeader from '../../components/WorkHeader';

import { getProject } from '../../config/general';
import hardcodedStaticProps from '../../lib/harcodedStaticProps';

const ITHongKong = ({featuredProjectsList}) => {
  const project = getProject('i-t-hong-kong');

  return (
    <Layout metaData={{ data: project }} featuredProjectsList={featuredProjectsList}>
      <article className="components page">
        <WorkHeader component={{ project }} />

        <VimeoVideo
          component={{
            video: '304110515',
            posterVideo: '304110515'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="pioneering-a-future-of-fashion">
            Pioneering a future of fashion
          </h2>
          <p>
            To celebrate their 30th anniversary, I.T commissioned some of the
            world’s leading fashion designers to co-create a unique collection
            of global exclusives.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20190429121427/1.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <p>
            To showcase the garments a traveling pop-up exhibition was created,
            designed by Jamie Fobert. We were invited to create the interactive
            aspect of the exhibition, in collaboration with The Fabricant.
          </p>
        </AnimateIn>

        <Image
          component={{
            image: '//images.yourmajesty.co/20190429121640/3.jpg',
            caption:
              'Using a mix of preprogrammed and interactive displays we created a surreal maze consisting of humanoid figures, rendered in real-time 3d, and buyable garments. The humanoids appeared to be alive as they responded to shoppers’ movements.'
          }}
        />

        <Image
          component={{
            image: '//images.yourmajesty.co/20190429121739/4.jpg',
            caption:
              'Camera’s mounted above the screens used object detection to track shopper movements. The 3D models were rendered in three.js and time synced with videos of the digital garments across 16 LED displays.'
          }}
        />

        <Image
          component={{
            image: '//images.yourmajesty.co/20190429121828/2.jpg'
          }}
        />

        <AnimateIn className="text g-row">
          <h2 id="on-a-global-tour">On a global tour</h2>
          <p>
            The installation travelled to Hong Kong, Shanghai, and Beijing in
            the winter of 2018, and continued its way through Europe in the
            beginning of 2019.
          </p>
        </AnimateIn>

        <AnimateIn className="text g-row">
          <h2 id="curious-to-know-more-">Curious to know more?</h2>
          <p>
            Learn more about our expertise in retail innovation, by sending us a
            note to{' '}
            <a href="mailto: hello@yourmajesty.co">
              hello@yourmajesty.co
            </a>
            , or check out our case-studies for{' '}
            <Link href="/work/samsung-cl">
              <a>Samsung</a>
            </Link>{' '}
            or{' '}
            <Link href="/work/adidas">
              <a>adidas</a>
            </Link>
            .
          </p>

          <h2 id="collaborators">Collaborators</h2>
          <p>
            <a href="https://www.thefabricant.com/" target="_blank" rel="noopener">
              The Fabricant
            </a>
            <br />
            <a href="https://www.amberjaeslooten.com/" target="_blank" rel="noopener">
              Amber Jae Slooten
            </a>
            <br />
            <a href="http://jamiefobertarchitects.com/" target="_blank" rel="noopener">
              Jamie Fobert
            </a>
          </p>
        </AnimateIn>

        <LinkList
          component={{
            title: 'Press',
            useLinksDirectly: true,
            links: [
              {
                title:
                  'I.T celebrates 30th anniversary with immersive Jamie Fobert-designed installation',
                url:
                  'https://www.wallpaper.com/fashion/it-30-anniversary-jamie-fobert',
                source: 'wallpaper'
              },
              {
                title:
                  'I.T celebrates 30th anniversary with special exhibition',
                url:
                  'https://hashtaglegend.com/events/it-celebrates-30th-anniversary',
                source: '#legend'
              },
              {
                title:
                  'Hong Kong’s I.T Teams Up With More Than 100 Luxe Brands for 30th Anniversary',
                url:
                  'https://www.highsnobiety.com/p/it-30th-anniversary-merch/',
                source: 'Highsnobiety'
              },
              {
                title:
                  'Into digital fashion? These Frame Lab exhibitors can show you what you’ll shop for in the future',
                url:
                  'https://www.frameweb.com/news/the-fabricant-digital-fashion-frame-lab-2019',
                source: 'Frame'
              },
              {
                title: 'Digital exhibition marks I.T’s 30th anniversary',
                url:
                  'https://insideretail.hk/2018/10/29/digital-exhibition-marks-i-ts-30th-anniversary/',
                source: 'Inside Retail Hong Kong'
              }
            ]
          }}
        />

        <ColumnLists
          className="g-row"
          component={{
            title: 'Services',
            columns: [
              {
                title: 'Strategy',
                items: ['Creative Strategy', 'Experience Mapping']
              },

              {
                title: 'Design',
                items: ['3D Design', 'Creative Direction', 'Motion Design']
              },

              {
                title: 'Experiential',
                items: [
                  'Hardware Specification',
                  'Installation Prototyping',
                  'Interactive Environment'
                ]
              }
            ]
          }}
        />
      </article>
    </Layout>
  );
};

export { hardcodedStaticProps as getStaticProps };

export default ITHongKong;
